var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[(_vm.loginUserInfo.auth_order_nomal)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'Order',
          'loadHTML_forOrder',
          {},
          '/tab/order-simple',
          '/order/#/tab/order-simple'
        )}}},[_vm._v("簡易発注")])]):_vm._e(),(
      _vm.loginUserInfo.auth_order_nomal &&
        _vm.order_screen_ptn_di != 'A03' &&
        _vm.order_screen_ptn_di != 'A04' &&
        _vm.order_screen_ptn_di != 'A05' &&
        _vm.order_screen_ptn_di != 'A06'
    )?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'Order',
          'loadHTML_forOrder',
          {},
          '/tab/order-hand',
          '/order/#/tab/order-hand'
        )}}},[_vm._v("手書き発注")])]):_vm._e(),(
      _vm.loginUserInfo.auth_order_nomal &&
        _vm.loginUserInfo.bulkorder_fg &&
        _vm.order_screen_ptn_di != 'A03' &&
        _vm.order_screen_ptn_di != 'A04' &&
        _vm.order_screen_ptn_di != 'A05' &&
        _vm.order_screen_ptn_di != 'A06'
    )?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'Order',
          'loadHTML_forOrder',
          {},
          '/tab/order-bulk',
          '/order/#/tab/order-bulk'
        )}}},[_vm._v("まとめ発注")])]):_vm._e(),(_vm.loginUserInfo.auth_order_file)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'order-file' },"active-class":"active"}},[_vm._v("ファイル発注")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }